import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { isEmpty } from 'lodash'
import { GlobalContext } from '../../context/GlobalState'

const LEAD_STAGES = ['Open', 'Converted', 'Not interested', 'Follow up']
const ManageLead = (props) => {
  const { openModal, onCancel, leadData, addCallback, editCallback } = props
  const { userObj } = useContext(GlobalContext)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [leadStage, setLeadStage] = useState('')
  const [comments, setComments] = useState([])
  const [newComment, setNewComment] = useState('')

  useEffect(() => {
    if (!isEmpty(leadData)) {
      setName(leadData.name)
      setEmail(leadData.email)
      setPhone(leadData.phone)
      setLeadStage(leadData.lead_stage)
      setComments(!isEmpty(leadData.comments) ? leadData.comments : [])
    }
  }, [leadData])

  const handleChange = (event, func) => {
    const { value } = event.target
    func(value)
  }

  const handleCreate = async () => {
    isEmpty(leadData)
      ? addCallback({
          name,
          phone,
          email,
          lead_stage: leadStage,
          comments,
        })
      : editCallback(leadData._id, {
          name: name,
          phone: phone,
          email: email,
          lead_stage: leadStage,
          comments: [
            { comment: newComment, created_date: new Date(), commented_by: userObj.name },
            ...comments,
          ],
        })
  }

  const handleLeadStageChange = (event) => {
    let { value } = event.target
    setLeadStage(value)
  }

  return (
    <>
      <CModal size="xl" visible={openModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{isEmpty(leadData) ? `Add Lead` : `Edit Lead`} </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow>
            <CCol>
              <CFormLabel>Name*</CFormLabel>
              <CFormInput
                type="text"
                value={name}
                name="name"
                onChange={(e) => handleChange(e, setName)}
              />
              {/*<div className="message-text error-message">*/}
              {/*  <p>{errorData.name}</p>*/}
              {/*</div>*/}
            </CCol>
            <CCol>
              <CFormLabel>Phone</CFormLabel>
              <CFormInput
                type="number"
                value={phone}
                min="0"
                name="phone"
                onChange={(e) => handleChange(e, setPhone)}
              />
              {/*<div className="message-text error-message">*/}
              {/*  <p>{errorData.phone}</p>*/}
              {/*</div>*/}
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol>
              <CFormLabel>Email</CFormLabel>
              <CFormInput
                type="email"
                value={email}
                name="email"
                onChange={(e) => handleChange(e, setEmail)}
              />
              {/*<div className="message-text error-message">*/}
              {/*  <p>{errorData.email}</p>*/}
              {/*</div>*/}
            </CCol>
            <CCol style={{ position: 'relative' }}>
              <CFormLabel>Lead Stage</CFormLabel>
              <CFormSelect
                className=""
                value={leadStage}
                onChange={(e) => handleLeadStageChange(e)}
              >
                <option disabled value="" selected>
                  Select Option
                </option>
                {LEAD_STAGES.map((ele, index) => (
                  <option value={ele} key={index}>
                    {ele}
                  </option>
                ))}
              </CFormSelect>
            </CCol>
          </CRow>

          <CRow className="mt-3">
            <CCol>
              <CFormLabel>Comments*</CFormLabel>
              <CFormTextarea
                rows="2"
                value={newComment}
                onChange={(e) => setNewComment(e.target.value)}
              />
            </CCol>
          </CRow>
          {comments &&
            comments.map((comment, index) => (
              <div key={index} style={{ border: '0.7px solid', padding: '5px', marginTop: '5px' }}>
                <p style={{ margin: '0px !important' }}>{comment.comment}</p>
                <p style={{ margin: '0px !important' }}>
                  By {comment.commented_by} | On {comment.created_date}
                </p>
              </div>
            ))}
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={onCancel}>
            Cancel
          </CButton>
          <CButton className="text-white" color="info" onClick={handleCreate}>
            Submit
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ManageLead
